.wrapper {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
}

.table th {
  text-align: left;
  font-weight: 600;
  color: var(--ink-soft);
  text-transform: uppercase;
  letter-spacing: 0.02em;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid var(--rule-strong);
  white-space: nowrap;
}

.table td {
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid var(--rule);
  color: var(--ink);
}

.table tbody tr:hover {
  background: color-mix(in srgb, var(--teal-500) 6%, transparent);
}
